import {identityVerificationSvg as Icon__small__identityVerificationSvg} from '../Icon__small/Icon__small--identityVerification.js'

export var identityVerification = {
  name: 'identityVerification',
  category: 'icon',
  colorable: true,
  svg: Icon__small__identityVerificationSvg,
};
